import { randomInt } from './random-int.js';

const randomItem = (list) => list[randomInt(list.length)];

export { randomItem };
//# sourceMappingURL=random-item.js.map
